import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0723c425"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "data-top" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "right-select" }
const _hoisted_5 = { style: {"margin-top":"20px"} }
const _hoisted_6 = { class: "finish-info" }
const _hoisted_7 = { class: "finish-info" }
const _hoisted_8 = { class: "finish-info" }
const _hoisted_9 = { class: "data-top-bottom" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "right-select" }
const _hoisted_12 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = { style: {"color":"red","font-weight":"500"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_18 = { class: "from-item" }
const _hoisted_19 = { style: {"margin-top":"20px"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "read-title" }, "今日", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "read-title" }, "昨日", -1))

import {
  ordersList,
  newUserList,
  historyToDay,
  historyYesToDay,
  orderInTime,
  orderInTimeList,
} from "@/api/api";
import { ts_to_time } from "@/utils/utils";
import {
  ref,
  defineAsyncComponent,
  onMounted,
  watch,
  reactive,
  nextTick,
  onBeforeUnmount,
} from "vue";
import { onBeforeRouteLeave } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'statistics',
  props: {
    appData: {},
    isRefresh: { type: Boolean },
    dbName: {}
  },
  setup(__props: any) {

const XATable = defineAsyncComponent(() => import("../components/XATable.vue"));
const props = __props;

const normalColumns = ref([
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    align: "center",
    customRender: (column: { index: number }) => {
      //   return (pageNo.value - 1) * pageSize.value + column.index + 1;
      return column.index + 1;
    },
    width: 50,
  },
  {
    title: "书名/剧名",
    key: "name",
    dataIndex: "name",
    ellipsis: true,
    width: 140,
  },
  {
    title: "订单",
    key: "orders",
    dataIndex: "orders",
    slots: {
      customRender: "orders",
    },
  },
  {
    title: "汇总",
    key: "amount",
    dataIndex: "amount",
    slots: {
      customRender: "amount",
    },
  },
]);
const vipColumns = ref([
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    align: "center",
    customRender: (column: { index: number }) => {
      //   return (pageNo.value - 1) * pageSize.value + column.index + 1;
      return column.index + 1;
    },
    width: 50,
  },
  {
    title: "价格",
    key: "price",
    dataIndex: "price",
    slots: {
      customRender: "price",
    },
  },
  {
    title: "订单",
    key: "orders",
    dataIndex: "orders",
    slots: {
      customRender: "orders",
    },
  },
  {
    title: "汇总",
    key: "amount",
    dataIndex: "amount",
    slots: {
      customRender: "amount",
    },
  },
]);
const svipColumns = ref([
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    align: "center",
    customRender: (column: { index: number }) => {
      //   return (pageNo.value - 1) * pageSize.value + column.index + 1;
      return column.index + 1;
    },
    width: 50,
  },
  {
    title: "时间",
    key: "time",
    dataIndex: "time",
  },
  {
    title: "订单",
    key: "orders",
    dataIndex: "orders",
    slots: {
      customRender: "orders",
    },
  },
  {
    title: "汇总",
    key: "amount",
    dataIndex: "amount",
    slots: {
      customRender: "amount",
    },
  },
]);
const userListColumns = ref([
  {
    title: "注册时间",
    key: "regTime",
    dataIndex: "regTime",
    isAllTime: true,
  },
  {
    title: "地区",
    key: "ipName",
    dataIndex: "ipName",
  },
  {
    title: "用户名",
    key: "userName",
    dataIndex: "userName",
  },
  //   {
  //     title: "UID",
  //     key: "time",
  //     dataIndex: "time",
  //   },
  {
    title: "类型",
    key: "time",
    dataIndex: "time",
    customRender: (column: { index: number }) => {
      return "短剧";
    },
  },
  {
    title: "书名/剧名",
    key: "videoName",
    dataIndex: "videoName",
  },
  {
    title: "最后阅读记录",
    key: "chapterTitle",
    dataIndex: "chapterTitle",
  },
  {
    title: "最后阅读时间",
    key: "readTime",
    dataIndex: "readTime",
    isAllTime: true,
  },
  {
    title: "订单数",
    key: "orders",
    dataIndex: "orders",
  },
  {
    title: "书币",
    key: "coins",
    dataIndex: "coins",
  },
]);
const historyToDayColumns = ref([
  {
    title: "平台",
    key: "packageName",
    dataIndex: "packageName",
  },
  {
    title: "阅读用户",
    key: "readUserCount",
    dataIndex: "readUserCount",
  },
  {
    title: "阅读记录",
    key: "readTotalCount",
    dataIndex: "readTotalCount",
  },
  {
    title: "观看用户",
    key: "lookUserCount",
    dataIndex: "lookUserCount",
  },
  {
    title: "观看记录",
    key: "lookTotalCount",
    dataIndex: "lookTotalCount",
  },
  {
    title: "书币消耗",
    key: "coins",
    dataIndex: "coins",
  },
]);
const historyYesToDayColumns = ref([
  {
    title: "平台",
    key: "packageName",
    dataIndex: "packageName",
  },
  {
    title: "阅读用户",
    key: "readUserCount",
    dataIndex: "readUserCount",
  },
  {
    title: "阅读记录",
    key: "readTotalCount",
    dataIndex: "readTotalCount",
  },
  {
    title: "观看用户",
    key: "lookUserCount",
    dataIndex: "lookUserCount",
  },
  {
    title: "观看记录",
    key: "lookTotalCount",
    dataIndex: "lookTotalCount",
  },
  {
    title: "书币消耗",
    key: "coins",
    dataIndex: "coins",
  },
]);
const newOrderColumns = ref([
  {
    title: "平台",
    key: "packageName",
    dataIndex: "packageName",
  },
  {
    title: "订单时间",
    key: "orderTime",
    dataIndex: "orderTime",
    isAllTime: true,
    width: 160,
  },
  {
    title: "订单信息",
    key: "amount",
    dataIndex: "amount",
    slots: {
      customRender: "amount",
    },
  },
  {
    title: "用户",
    key: "userName",
    dataIndex: "userName",
  },
  {
    title: "地区",
    key: "ipName",
    dataIndex: "ipName",
  },
  {
    title: "总充值",
    key: "userAmountTotal",
    dataIndex: "userAmountTotal",
    slots: {
      customRender: "userAmountTotal",
    },
  },
  {
    title: "剧名",
    key: "moduleType",
    dataIndex: "moduleType",
    slots: {
      customRender: "moduleType",
    },
  },
]);
const normalData = reactive({ top: {}, bottom: [] } as any);
const vipData = reactive({ top: {}, bottom: [] } as any);
const svipData = reactive({ top: {}, bottom: [] } as any);
const bottomHeight = ref();
const userList = ref([]);
const historyToDayList = ref([]);
const historyYesToDayList = ref([]);
const newUserInfos = ref([]);
const newUserInfo = ref({} as any);
const checkedValue = ref<boolean>(true);
const newOrderTimer = ref();
var voicedOrderNos: any[] = [];
const orderAllLoading = ref(false);
const newUserLoading = ref(false);
const readLookLoading = ref(false);
const newOrderLoading = ref(false);
var appIdList: any[] = [];
const appIdVal = ref();
const rightAppIdVal = ref<any[]>([]);
const maxTagCount = ref(1);
const allOrderTimer = ref();
const newUserListTimer = ref();

const getOrderList = () => {
  orderAllLoading.value = true;
  ordersList({ dbName: appIdVal.value }).then((res) => {
    orderAllLoading.value = false;
    res.data[0][0].subs.forEach((item: any) => {
      if (item.type === 1) {
        normalData.top = item;
      } else if (item.type === 2) {
        vipData.top = item;
      } else if (item.type === 3) {
        svipData.top = item;
      }
    });

    normalData.bottom = res.data[1];
    vipData.bottom = res.data[2];
    svipData.bottom = res.data[3];
  });
};

const getNewUserList = () => {
  newUserLoading.value = true;
  newUserList({ dbName: appIdVal.value }).then((res) => {
    newUserLoading.value = false;
    userList.value = res.data;
  });
};

const getHistoryToDay = () => {
  readLookLoading.value = true;
  historyToDay({
    dbName: decodeURIComponent(rightAppIdVal.value.join(",")),
  })
    .then((res) => {
      readLookLoading.value = false;
      historyToDayList.value = res.data;
    })
    .catch(() => {
      readLookLoading.value = false;
    });
};

const getHistoryYesToDay = () => {
  readLookLoading.value = true;
  historyYesToDay({
    dbName: decodeURIComponent(rightAppIdVal.value.join(",")),
  })
    .then((res) => {
      readLookLoading.value = false;
      historyYesToDayList.value = res.data;
    })
    .catch(() => {
      readLookLoading.value = false;
    });
};

const startVoiceTimer = () => {
  stopVoiceTimer();
  newOrderTimer.value = setInterval(() => {
    getOrderInTime();
  }, 2000);
};

const stopVoiceTimer = () => {
  if (newOrderTimer.value) {
    clearInterval(newOrderTimer.value);
    newOrderTimer.value = null;
  }
};

const getOrderInTime = () => {
  stopVoiceTimer();
  newOrderLoading.value = true;
  orderInTime({ dbName: decodeURIComponent(rightAppIdVal.value.join(",")) })
    .then((res) => {
      newOrderLoading.value = false;
      startVoiceTimer();
      if (res.data.length > 0) {
        newUserInfo.value = res.data[0];
        voicedOrderNos = JSON.parse(
          localStorage.getItem("voicedOrderNos") as string
        )
          ? JSON.parse(localStorage.getItem("voicedOrderNos") as string)
          : [];
        if (!voicedOrderNos.includes(newUserInfo.value.orderNo)) {
          if (checkedValue.value) {
            var voiceStr: string =
              newUserInfo.value.packageName +
              "有新订单，充值金额为" +
              (newUserInfo.value.amount / 100).toFixed(2) +
              (newUserInfo.value.name
                ? "，剧名为：" + newUserInfo.value.name
                : "，没有剧名");
            speak(voiceStr);
          }
          voicedOrderNos.push(newUserInfo.value.orderNo);
          localStorage.setItem(
            "voicedOrderNos",
            JSON.stringify(voicedOrderNos)
          );
          getOrderInTimeList();
          // newUserInfos.value.push(newUserInfo.value)
          // localStorage.setItem("MONITOR",newUserInfo.value)
        }
      }
    })
    .catch(() => {
      startVoiceTimer();
    });
};

// const getMoniTorData = () => {

//   newUserInfos.value = JSON.parse(localStorage.getItem("MONITOR") as string)

// }

const getOrderInTimeList = () => {
  orderInTimeList({
    dbName: `${decodeURIComponent(rightAppIdVal.value.join(","))}`,
  }).then((res) => {
    newUserInfos.value = res.data;
  });
};

const getAllOrderTimer = () => {
  getOrderList();
  if (rightAppIdVal.value.length) {
    getHistoryToDay();
    getHistoryYesToDay();
  }

  clearInterval(allOrderTimer.value);
  allOrderTimer.value = null;
  allOrderTimer.value = setInterval(() => {
    getOrderList();
    if (rightAppIdVal.value.length) {
      getHistoryToDay();
      getHistoryYesToDay();
    }
  }, 1000 * 120);
};

const getNewUserListTimer = () => {
  getNewUserList();

  clearInterval(newUserListTimer.value);
  newUserListTimer.value = null;
  newUserListTimer.value = setInterval(() => {
    getNewUserList();
  }, 1000 * 600);
};
const stopAllTimer = () => {
  stopVoiceTimer();
  clearInterval(allOrderTimer.value);
  allOrderTimer.value = null;
  clearInterval(newUserListTimer.value);
  newUserListTimer.value = null;
};
watch(
  () => props.appData,
  (cur, old) => {
    if (cur && cur.length) {
      appIdList = [];
      cur.forEach((val: { dbName: any }) => {
        appIdList.push(val.dbName);
      });
      if (localStorage.getItem("APPIDLIST")) {
        rightAppIdVal.value = JSON.parse(
          localStorage.getItem("APPIDLIST") as string
        );
      } else {
        rightAppIdVal.value = appIdList;
      }
      if (localStorage.getItem("APPID")) {
        appIdVal.value = localStorage.getItem("APPID");
      } else {
        appIdVal.value = cur[0].dbName;
      }

      getNewUserListTimer();
      getAllOrderTimer();

      if (rightAppIdVal.value.length) {
        newUserInfos.value = [];
        newUserInfo.value = {};
        getOrderInTime();
        getOrderInTimeList();
      }
    }
  },
  { immediate: true, deep: true }
);

watch(
  () => props.isRefresh,
  (cur, old) => {
    if (appIdVal.value) {
      getNewUserListTimer();
      getAllOrderTimer();
      newUserInfos.value = [];
      newUserInfo.value = {};
      getOrderInTime();
    }
  }
);

const rightAppIdValChange = (val: any[]) => {
  localStorage.setItem("APPIDLIST", JSON.stringify(val));
  if (val.length) {
    startVoiceTimer();
  } else {
    stopVoiceTimer();
  }
};

const appIdChange = (val: string) => {
  localStorage.setItem("APPID", val);
  getOrderList();
  getNewUserList();
};

const getBottomHeight = () => {
  if (window.innerHeight < 1150) {
    return;
  }
  bottomHeight.value = window.innerHeight - 800;
};

const voiceChange = (val: any) => {
  localStorage.setItem("VOICE", val);
};

const speak = (textStr: string) => {
  // 获取输入框中的文本
  const text = textStr;
  // 创建一个新的SpeechSynthesisUtterance对象
  const utterance = new SpeechSynthesisUtterance(text);
  // 设置语音属性（可选）
  utterance.lang = "zh-CN"; // 设置语言为中文
  utterance.pitch = 1; // 设置音调
  utterance.rate = 1; // 设置语速
  utterance.volume = 1; // 设置音量
  // 使用speechSynthesis对象播报文本
  window.speechSynthesis.speak(utterance);
};
const isOpenVoice = () => {
  if (localStorage.getItem("VOICE") === "true") {
    checkedValue.value = true;
  } else if (localStorage.getItem("VOICE") === "false") {
    checkedValue.value = false;
  } else {
    checkedValue.value = true;
  }
};
onMounted(() => {
  isOpenVoice();
  getBottomHeight();
  window.addEventListener("resize", function () {
    // 获取浏览器窗口的新高度
    const windowHeight = window.innerHeight;

    // 在这里处理窗口高度变化的逻辑，比如更新数据或触发其他操作
    getBottomHeight();
  });

  nextTick(() => {
    isOpenVoice();
  });
});

onBeforeUnmount(() => {
  //console.log("离开");
  stopAllTimer();
});

return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_switch = _resolveComponent("a-switch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, {
        gutter: 30,
        class: "a-row-content"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 16 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_divider, { orientation: "left" }, {
                          default: _withCtx(() => [
                            _createTextVNode("订单汇总")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_a_select, {
                            ref: "select",
                            value: appIdVal.value,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((appIdVal).value = $event)),
                            onChange: appIdChange,
                            style: {"width":"120px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appData, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.dbName,
                                  value: item.dbName
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.packageName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", null, [
                  _createVNode(_component_a_row, { gutter: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_spin, { spinning: orderAllLoading.value }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_card, {
                                title: "普通充值",
                                bordered: false,
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_statistic, {
                                    value: 
                          normalData.top.amount === null
                            ? 0
                            : (normalData.top.amount / 100).toFixed(2)
                        
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["spinning"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_spin, { spinning: orderAllLoading.value }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_card, {
                                title: "VIP会员",
                                bordered: false,
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_statistic, {
                                    value: 
                          vipData.top.amount === null
                            ? 0
                            : (vipData.top.amount / 100).toFixed(2)
                        
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["spinning"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_spin, { spinning: orderAllLoading.value }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_card, {
                                title: "SVIP会员",
                                bordered: false,
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_statistic, {
                                    value: 
                          svipData.top.amount === null
                            ? 0
                            : (svipData.top.amount / 100).toFixed(2)
                        
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["spinning"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_a_row, { gutter: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_spin, { spinning: orderAllLoading.value }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_card, {
                                title: "完成情况",
                                bordered: false,
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", null, _toDisplayString(!normalData.top.payNum ? 0 : normalData.top.payNum), 1),
                                    _createVNode(_component_a_divider, { type: "vertical" }),
                                    _createElementVNode("div", null, _toDisplayString(!normalData.top.unPayNum
                              ? 0
                              : normalData.top.unPayNum), 1),
                                    _createVNode(_component_a_divider, { type: "vertical" }),
                                    _createElementVNode("div", null, _toDisplayString(!normalData.top.successPer
                              ? 0
                              : normalData.top.successPer) + "% ", 1)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["spinning"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_spin, { spinning: orderAllLoading.value }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_card, {
                                title: "完成情况",
                                bordered: false,
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", null, _toDisplayString(!vipData.top.payNum ? 0 : vipData.top.payNum), 1),
                                    _createVNode(_component_a_divider, { type: "vertical" }),
                                    _createElementVNode("div", null, _toDisplayString(!vipData.top.unPayNum ? 0 : vipData.top.unPayNum), 1),
                                    _createVNode(_component_a_divider, { type: "vertical" }),
                                    _createElementVNode("div", null, _toDisplayString(!vipData.top.successPer
                              ? 0
                              : vipData.top.successPer) + "% ", 1)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["spinning"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_spin, { spinning: orderAllLoading.value }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_card, {
                                title: "完成情况",
                                bordered: false,
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("div", null, _toDisplayString(!svipData.top.payNum ? 0 : svipData.top.payNum), 1),
                                    _createVNode(_component_a_divider, { type: "vertical" }),
                                    _createElementVNode("div", null, _toDisplayString(!svipData.top.unPayNum ? 0 : svipData.top.unPayNum), 1),
                                    _createVNode(_component_a_divider, { type: "vertical" }),
                                    _createElementVNode("div", null, _toDisplayString(!svipData.top.successPer
                              ? 0
                              : svipData.top.successPer) + "% ", 1)
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["spinning"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_a_row, { gutter: 16 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 10 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(XATable), {
                            columns: normalColumns.value,
                            dataSource: normalData.bottom,
                            scroll: { y: 160 },
                            size: "small",
                            height: "200px",
                            loading: orderAllLoading.value
                          }, {
                            amount: _withCtx(({ scope }) => [
                              _createTextVNode(_toDisplayString((scope.record.amount / 100).toFixed(2)), 1)
                            ]),
                            orders: _withCtx(({ scope }) => [
                              _createTextVNode(_toDisplayString(scope.record.currentOrder + " / " + scope.record.orders), 1)
                            ]),
                            _: 1
                          }, 8, ["columns", "dataSource", "loading"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 7 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(XATable), {
                            columns: vipColumns.value,
                            dataSource: vipData.bottom,
                            scroll: { y: 160 },
                            size: "small",
                            height: "200px",
                            loading: orderAllLoading.value
                          }, {
                            amount: _withCtx(({ scope }) => [
                              _createTextVNode(_toDisplayString((scope.record.amount / 100).toFixed(2)), 1)
                            ]),
                            orders: _withCtx(({ scope }) => [
                              _createTextVNode(_toDisplayString(scope.record.currentOrder + " / " + scope.record.orders), 1)
                            ]),
                            price: _withCtx(({ scope }) => [
                              _createTextVNode(_toDisplayString((scope.record.price / 100).toFixed(2)), 1)
                            ]),
                            _: 1
                          }, 8, ["columns", "dataSource", "loading"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 7 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(XATable), {
                            columns: svipColumns.value,
                            dataSource: svipData.bottom,
                            scroll: { y: 160 },
                            size: "small",
                            height: "200px",
                            loading: orderAllLoading.value
                          }, {
                            amount: _withCtx(({ scope }) => [
                              _createTextVNode(_toDisplayString((scope.record.amount / 100).toFixed(2)), 1)
                            ]),
                            orders: _withCtx(({ scope }) => [
                              _createTextVNode(_toDisplayString(scope.record.currentOrder + " / " + scope.record.orders), 1)
                            ]),
                            _: 1
                          }, 8, ["columns", "dataSource", "loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { span: 12 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_a_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 16 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_divider, { orientation: "left" }, {
                          default: _withCtx(() => [
                            _createTextVNode("最新订单")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_a_select, {
                            ref: "select",
                            value: rightAppIdVal.value,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((rightAppIdVal).value = $event)),
                            mode: "multiple",
                            onChange: rightAppIdValChange,
                            "max-tag-count": maxTagCount.value,
                            style: {"min-width":"120px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appData, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.dbName,
                                  value: item.dbName
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.packageName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value", "max-tag-count"])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions, {
                  title: "用户信息",
                  column: { xxl: 4, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_descriptions_item, { label: "用户名" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(newUserInfo.value.userName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "注册时间" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(newUserInfo.value.regTime
                  ? _unref(ts_to_time)(newUserInfo.value.regTime * 1000)
                  : ""), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "地区" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(newUserInfo.value.ipName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "总值" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString((newUserInfo.value.userPayTotal ? newUserInfo.value.userPayTotal : "") +
                (newUserInfo.value.userAmountTotal
                  ? " | " + (newUserInfo.value.userAmountTotal / 100).toFixed(2)
                  : "")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_row, {
                  gutter: 10,
                  style: {"margin-top":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_descriptions, {
                          title: "订单信息",
                          column: { xxl: 4, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_descriptions_item, { label: "" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_12, [
                                  _createTextVNode(" 平台：" + _toDisplayString(newUserInfo.value.packageName), 1),
                                  _hoisted_13,
                                  _createTextVNode(" 时间：" + _toDisplayString(newUserInfo.value.orderTime
                          ? _unref(ts_to_time)(newUserInfo.value.orderTime * 1000)
                          : ""), 1),
                                  _hoisted_14,
                                  _createElementVNode("div", null, [
                                    _createTextVNode(" 金额："),
                                    _createElementVNode("text", _hoisted_15, _toDisplayString(newUserInfo.value.amount
                              ? "$" + (newUserInfo.value.amount / 100).toFixed(2)
                              : "") + " " + _toDisplayString(newUserInfo.value.moduleType
                              ? newUserInfo.value.moduleType === 0
                                ? " | 小说"
                                : newUserInfo.value.moduleType === 1
                                ? " | 短剧"
                                : ""
                              : "") + _toDisplayString(newUserInfo.value.goodsName
                              ? " | " + newUserInfo.value.goodsName
                              : ""), 1)
                                  ]),
                                  _createTextVNode(" 剧名：" + _toDisplayString(newUserInfo.value.name), 1),
                                  _hoisted_16
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_descriptions, {
                          title: "监听配置",
                          column: { xxl: 4, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_descriptions_item, { label: "" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("div", _hoisted_18, [
                                    _createTextVNode(" 语音播报： "),
                                    _createVNode(_component_a_switch, {
                                      style: {"margin-left":"10px"},
                                      checked: checkedValue.value,
                                      "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((checkedValue).value = $event)),
                                      onChange: voiceChange
                                    }, null, 8, ["checked"])
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createTextVNode(" 监听状态："),
                                    _createElementVNode("span", {
                                      style: _normalizeStyle({
                            color: rightAppIdVal.value.length > 0 ? 'green' : 'red',
                          })
                                    }, _toDisplayString(rightAppIdVal.value.length > 0
                              ? "监听中..."
                              : "已停止监听"), 5)
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createElementVNode("div", null, [
                  _createVNode(_unref(XATable), {
                    columns: newOrderColumns.value,
                    dataSource: newUserInfos.value,
                    scroll: { y: 160 },
                    size: "small",
                    height: "200px"
                  }, {
                    amount: _withCtx(({ scope }) => [
                      _createTextVNode(_toDisplayString(scope.record.type === 1
                      ? "充值 | "
                      : scope.record.type === 2
                      ? "VIP | "
                      : scope.record.type === 3
                      ? "SVIP | "
                      : "") + "$" + _toDisplayString(scope.record.amount
                      ? (scope.record.amount / 100).toFixed(2)
                      : 0), 1)
                    ]),
                    userAmountTotal: _withCtx(({ scope }) => [
                      _createTextVNode(_toDisplayString(scope.record.userPayTotal) + " | " + _toDisplayString("$" + (scope.record.userAmountTotal / 100).toFixed(2)), 1)
                    ]),
                    moduleType: _withCtx(({ scope }) => [
                      _createTextVNode(_toDisplayString(scope.record.name), 1)
                    ]),
                    _: 1
                  }, 8, ["columns", "dataSource"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_a_row, {
        gutter: 30,
        class: "a-row-content"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_divider, { orientation: "left" }, {
                default: _withCtx(() => [
                  _createTextVNode("新用户数据")
                ]),
                _: 1
              }),
              _createVNode(_unref(XATable), {
                columns: userListColumns.value,
                dataSource: userList.value,
                scroll: { y: bottomHeight.value },
                size: "small",
                height: bottomHeight.value + 60 + 'px',
                loading: newUserLoading.value
              }, null, 8, ["columns", "dataSource", "scroll", "height", "loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_col, { span: 12 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_divider, { orientation: "left" }, {
                default: _withCtx(() => [
                  _createTextVNode("阅读/观看数据")
                ]),
                _: 1
              }),
              _hoisted_20,
              _createVNode(_unref(XATable), {
                columns: historyToDayColumns.value,
                dataSource: historyToDayList.value,
                scroll: { y: bottomHeight.value / 2 - 10 - 50 },
                size: "small",
                height: (bottomHeight.value - 10) / 2 + 'px',
                loading: readLookLoading.value
              }, null, 8, ["columns", "dataSource", "scroll", "height", "loading"]),
              _hoisted_21,
              _createVNode(_unref(XATable), {
                columns: historyYesToDayColumns.value,
                dataSource: historyYesToDayList.value,
                scroll: { y: bottomHeight.value / 2 - 10 - 50 },
                size: "small",
                height: (bottomHeight.value - 10) / 2 + 'px',
                loading: readLookLoading.value
              }, null, 8, ["columns", "dataSource", "scroll", "height", "loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})